import { QueryClient } from "@tanstack/react-query";

// Some browsers report navigator.onLine === false while online (VPNs, security agents); the
// default "online" mode then pauses every request forever, leaving a blank screen.
const QUERY_NETWORK_MODE = "offlineFirst";

// Its own module so tests can run on the app's client without loading the app shell.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 5,
      networkMode: QUERY_NETWORK_MODE,
    },
    mutations: {
      networkMode: QUERY_NETWORK_MODE,
    },
  },
});
